<template>
  <div class="pages">
    <div class="bg">
      <img src="../../assets/images/activity/collect-cards-bg.png">
    </div>
    <div class="cards">
      <div class="cards-list">
        <span v-if="hasLetter('C')">
          <img src="../../assets/images/activity/collect-cards-light1.png" width="100%">
        </span>
        <span v-else>
          <img src="../../assets/images/activity/collect-cards-dark1.png" width="100%">
        </span>
        <span v-if="hasLetter('N')">
          <img src="../../assets/images/activity/collect-cards-light2.png" width="100%">
        </span>
        <span v-else>
          <img src="../../assets/images/activity/collect-cards-dark2.png" width="100%">
        </span>
        <span v-if="hasLetter('H')">
          <img src="../../assets/images/activity/collect-cards-light3.png" width="100%">
        </span>
        <span v-else>
          <img src="../../assets/images/activity/collect-cards-dark3.png" width="100%">
        </span>
        <span v-if="hasLetter('K')">
          <img src="../../assets/images/activity/collect-cards-light4.png" width="100%">
        </span>
        <span v-else>
          <img src="../../assets/images/activity/collect-cards-dark4.png" width="100%">
        </span>
        <!-- <img v-if="hasLetter('C')" src="../../assets/images/activity/collect-cards-light1.png" width="100%">
        <img v-else src="../../assets/images/activity/collect-cards-dark1.png" width="100%">
        <img v-if="hasLetter('N')" src="../../assets/images/activity/collect-cards-light2.png" width="100%">
        <img v-else src="../../assets/images/activity/collect-cards-dark2.png" width="100%">
        <img v-if="hasLetter('H')" src="../../assets/images/activity/collect-cards-light3.png" width="100%">
        <img v-else src="../../assets/images/activity/collect-cards-dark3.png" width="100%">
        <img v-if="hasLetter('K')" src="../../assets/images/activity/collect-cards-light4.png" width="100%">
        <img v-else src="../../assets/images/activity/collect-cards-dark4.png" width="100%"> -->
      </div>
      <p class="cards-desc">点亮所有“春暖花开”获得<span>神秘</span>奖励</p>
      <div class="schedule">
        <div class="schedule-wrapper">
          <div class="schedule-title">扫码进度条</div>
          <div class="schedule-content">
            <div class="schedule-count">已扫码:<span>{{ scanCount }}</span>次,每扫满10次可点亮一字</div>
            <div class="schedule-bar">
              <span :style="{ width: 10 * scanCount + '%' }"></span>
            </div>
            <div class="schedule-alert">一天最多点亮一字,获得一张抵扣券</div>
          </div>
        </div>
      </div>
      <div class="cards-price">集齐春暖花开免费领“春游养护季礼包”</div>
      <div class="cards-icon">
        <img v-if="giftTakeCount >= 300" src="../../assets/images/activity/collect-cards-finish.png">
        <img v-else-if="!hasCollectAll" src="../../assets/images/activity/collect-cards-alert1.png">
        <img v-else-if="hasTakeGift" src="../../assets/images/activity/collect-cards-has.png">
        <img v-else src="../../assets/images/activity/collect-cards-get.png" @click.stop="handleTakeGift">
      </div>
      <div class="cards-price">
        数量有限,先到先得
      </div>
      <div class="cards-join" @click="handleJumpScan">立即参与</div>
    </div>

    <div>
      <img src="../../assets/images/activity/collect-cards-price.png">
    </div>

    <div>
      <img src="../../assets/images/activity/collect-cards-detail.png">
    </div>

    <div class="activity-desc">
      <div class="desc-wrapper">
        <span style="font-weight: 600">参与对象：</span>
        <span>所有IAM修理厂用户</span>
      </div>
      <div class="desc-wrapper">
        <span style="font-weight: 600">活动时间：</span>
        <span>4月10日——4月17日</span>
      </div>
      <div class="desc-wrapper">
        <span style="font-weight: 600">活动内容：</span>
        <span style="padding-bottom: 5px">1、活动期间每扫满博世产品码10次即可点亮一个字，点亮后获得相应字的卡券积分抵用券，每日最多可点亮一次，获得一张积分抵扣券；依次扫码点亮“春、暖、花、开”，共可以获得4张积分卡券，提交订单时需手动选择使用相应积分抵扣券，积分抵扣券有效期为30天。</span>
        <span>2、点亮所有“春暖花开”后，免费领取“春游记DIY礼包”，礼包随未发货积分兑换订单一起寄出。</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import activityApi from '@/api/activity'
export default {
  name: 'ActivityCollectCards',
  data () {
    return {
      scanCountTotal: 0,
      scanCount: 0,
      giftTakeCount: 0,
      bonusLetters: [],
      hasCollectAll: false,
      hasTakeGift: false
    }
  },
  computed: {
    ...mapState({
      times: state => state.lottery.scanTimes
    })
  },
  created () {
    this.getCollectCardsRecord()
  },
  methods: {
    getCollectCardsRecord () {
      activityApi.getCollectCardsRecord().then(res => {
        if (res.data.resultCode === '0') {
          this.scanCount = res.data.resultData.scanCount > 10 ? 10 : res.data.resultData.scanCount
          this.giftTakeCount = res.data.resultData.giftTakeCount
          this.hasTakeGift = res.data.resultData.giftTake
          this.bonusLetters = res.data.resultData.bonusLetters
          if (this.bonusLetters.length >= 4) {
            this.hasCollectAll = true
          }
        }
      })
    },
    hasLetter (val) {
      if (this.bonusLetters.indexOf(val) !== -1) {
        return true
      } else {
        return false
      }
    },
    handleJumpScan () {
      this.$router.push({ name: 'lottery-home' })
    },
    handleTakeGift () {
      activityApi.takeCollectCardsGift().then(res => {
        if (res.data.resultCode === '0') {
          this.$dialog.alert({ message: '您已成功领取礼品！' })
          this.getCollectCardsRecord()
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.pages {
  background-color: #fff;
  width: calc(100vw);
  img {
    width: 100%;
  }
  .cards {
    box-sizing: border-box;
    width: 100%;
    padding: 110px 50px 0 50px;
    height: 418px;
    background: url('../../assets/images/activity/collect-cards-rule.png') no-repeat;
    background-size: 100%;
    text-align: center;
    .cards-list {
      display: flex;
      justify-content: space-around;
      width: 100%;
      span {
        width: 60px;
        height: 100%;
      }
    }
    .cards-desc {
      padding: 10px 0;
      color: #868686;
      span {
        color: #f25552;
      }
    }
    .schedule {
      font-size: 12px;
      .schedule-wrapper {
        display: flex;
        justify-content: space-around;
        align-items: center;
        .schedule-title {
          display:inline-block;
          width: 25%;
          font-weight: 600;
        }
        .schedule-content {
          display:inline-block;
          width: 75%;
          font-size: 10px;
        }
        .schedule-count {
          padding: 5px 0;
          span {
            font-size: 14px;
            font-weight: 600;
            color: #f25552;
          }
        }
        .schedule-bar {
          width: 200px;
          height: 10px;
          border: 1px solid #ccc;
          border-radius: 6px;
          text-align: left;
          span {
            display: inline-block;
            height: 100%;
            width: 0px;
            font-size: 0;
            vertical-align: baseline;
            border-radius: 6px;
            background-color: #3b8d97;
          }
        }
        .schedule-alert {
          padding: 5px;
        }
      }
    }
    .cards-price {
      padding: 5px 0;
      font-size: 10px;
      color: #999;
    }
    .cards-join {
      text-align: center;
      background-color: #9fcad0;
      color: #fff;
      width: 120px;
      line-height: 25px;
      margin: 0 auto;
      border-radius: 5px;
      font-size: 12px;
      font-weight: 600;
    }
    .cards-icon {
      img {
        width: 150px;
      }
    }
  }
  .activity-desc {
    box-sizing: border-box;
    width: 100%;
    height: 260px;
    font-size: 10px;
    padding: 65px 50px 0 50px;
    background: url('../../assets/images/activity/collect-cards-desc.png') no-repeat;
    background-size: 100%;
    .desc-wrapper {
      padding-bottom: 5px;
    }
    span {
      display: block;
    }
  }
}
</style>
